import { withAuthenticationRequired } from '@tom-ui/utils'
import { CompaniesContainer } from '@billing/features/company/containers/CompaniesContainer'
import { CompaniesDialogContainer } from '@billing/features/company/containers/CompaniesDialogContainer'
import { Box } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { useMinimalsTheme } from '@tom-ui/ui'
import { FC } from 'react'
import { Helmet } from 'react-helmet-async'

const Companies: FC = withAuthenticationRequired(() => {
  const { t } = useTranslate()
  const theme = useMinimalsTheme()

  return (
    <>
      <Helmet>
        <title>{t('companiesTomBillingService', 'Companies - TOM Billing Service')}</title>
      </Helmet>
      <Box
        sx={{
          height: '100%',
          bgcolor: theme.palette.grey[100],
        }}
      >
        <CompaniesContainer />
      </Box>
      <CompaniesDialogContainer />
    </>
  )
})

export default Companies
